import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    FLOATING_LABEL_CLASS_NAME,
    FLOATING_LABEL_USING_PLACEHOLDER_SHOWN_CLASS_NAME,
} from "../../../forms/classNames";
import { IReviewQueryFacets } from "../../../models/reviews";
import { useAppDispatch } from "../../../store/reducers";
import { TextFilterDisplay } from "../TextFilterDisplay";
import { updateFilterOptionValue } from "../reducers";

import styles from "./index.module.scss";

const FACET_TYPE: IReviewQueryFacets = "text";

type IProps = Immutable<{
    placeholder?: string;
    maxKeywordsNumber?: number;
}>;

export const TextFilter = (props: IProps): React.ReactNode => {
    const [currentText, setCurrentText] = React.useState("");
    const dispatch = useAppDispatch();

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        setCurrentText(e.currentTarget.value);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const query = currentText.trim();
        if (!query) {
            return;
        }
        dispatch(
            updateFilterOptionValue({
                facetType: FACET_TYPE,
                optionID: query,
                isSelected: true,
            }),
        );
        setCurrentText("");
    };

    return (
        <>
            <div
                key="text"
                className={`${styles.search} customer-review__side-filters__search`}
            >
                <div
                    className={`${styles.searchBar} customer-review__side-filters__search-bar`}
                >
                    <form
                        action=""
                        className={`${styles.searchForm} customer-review__side-filters__search-form`}
                        onSubmit={onSubmit}
                    >
                        <div
                            className={concatClassNames([
                                FLOATING_LABEL_CLASS_NAME,
                                FLOATING_LABEL_USING_PLACEHOLDER_SHOWN_CLASS_NAME,
                            ])}
                        >
                            <span className="ada-screenreader-only">
                                {t`Activating this element will cause content on the page to be updated`}
                            </span>
                            <input
                                className={`${styles.searchText} customer-review__side-filters__search-text`}
                                id="text"
                                type="text"
                                name="text"
                                onChange={onChange}
                                value={currentText}
                                placeholder={" "}
                            />
                            <label htmlFor="text">
                                {!props.placeholder
                                    ? t`Search Keywords`
                                    : props.placeholder}
                            </label>
                        </div>
                        <button
                            className={`${styles.searchSubmit} customer-review__side-filters__search-submit`}
                            type="submit"
                            aria-label={t`Search`}
                        >
                            <span
                                aria-hidden="true"
                                className={`${styles.searchIcon} customer-review__side-filters__search-submit__icon`}
                            ></span>
                        </button>
                    </form>
                </div>
            </div>
            <TextFilterDisplay maxKeywordsNumber={props.maxKeywordsNumber} />
        </>
    );
};
